export enum ContractTypeEnum {
    E_CONTRACT = 'e_contract',
    PHYSICAL_CONTRACT = 'physical_contract'
}